import { getTemplate, WidgetProps } from '@rjsf/utils';

const PerplexityDateFormatWidget = (props: WidgetProps) => {
  const BaseInputTemplate = getTemplate('BaseInputTemplate', props.registry, props.options);

  const formatForInput = (date?: string) => {
    if (!date?.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
      return date;
    }

    const [month, day, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  };

  const formatForOutput = (date?: string) => {
    if (!date?.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return date;
    }

    const [year, month, day] = date.split('-');
    return `${month}/${day}/${year}`;
  };

  const handleChange = (date: string) => {
    props.onChange(formatForOutput(date));
  };

  return <BaseInputTemplate {...props} type="date" value={formatForInput(props.value)} onChange={handleChange} />;
};

export default PerplexityDateFormatWidget;
